<template>
  <b-card no-body class="financial-card">
    <div class="financial-header">
      <span class="font-weight-bold">Financial Status</span>
    </div>
    <div class="financial-body">
      <div class="fin-row">
        <span class="fk">
          <feather-icon icon="CreditCardIcon" size="12" class="mr-1" />
          Financial Status
        </span>
        <span class="fv">
          <b-badge variant="success" style="font-size: 10px">Active</b-badge>
        </span>
      </div>
      <div class="fin-row">
        <span class="fk">
          <feather-icon icon="ZapIcon" size="12" class="mr-1" />
          Osko Payments
        </span>
        <span class="fv">
          <b-badge variant="secondary" style="font-size: 10px"
            >Disabled</b-badge
          >
        </span>
      </div>
      <div class="fin-row">
        <span class="fk">
          <feather-icon icon="ClockIcon" size="12" class="mr-1" />
          Osko Delay
        </span>
        <span class="fv">4 Minutes</span>
      </div>
      <div class="fin-actions">
        <b-button
          size="sm"
          variant="outline-secondary"
          class="flex-fill"
          style="font-size: 10px"
          @click="showModalBankAccount"
        >
          See Financial Config
        </b-button>
        <b-button
          size="sm"
          variant="outline-secondary"
          class="flex-fill"
          style="font-size: 10px"
          @click="showOskoProfileModal"
        >
          Edit Osko Profile
        </b-button>
      </div>
      <b-button
        variant="warning"
        class="w-100 mt-1"
        size="sm"
        style="font-size: 10px"
        @click="showModalFirstWithdrawal"
      >
        First Withdrawal Unverified
      </b-button>
    </div>
  </b-card>
</template>

<script>
import { BCard, BButton, BBadge } from "bootstrap-vue";

export default {
  components: { BCard, BButton, BBadge },
  methods: {
    showModalBankAccount() {
      this.$bvModal.show("bank-account-modal");
    },
    showOskoProfileModal() {
      this.$bvModal.show("osko-profile-modal");
    },
    showModalFirstWithdrawal() {
      this.$bvModal.show("first-withdrawal-modal");
    },
  },
};
</script>

<style lang="scss" scoped>
.financial-card {
  border: 1px solid #e2e6ea;
  border-radius: 6px;
  max-width: 100%;
}
.financial-header {
  background: #f8f9fa;
  padding: 8px 12px;
  border-bottom: 1px solid #e2e6ea;
  font-size: 12px;
  font-weight: 700;
  color: #1a1f36;
}
.financial-body {
  padding: 10px 12px;
}
.fin-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  font-size: 11px;
  border-bottom: 1px solid #f5f5f8;
}
.fin-row:last-of-type {
  border-bottom: none;
}
.fin-row .fk {
  color: #666;
  display: flex;
  align-items: center;
}
.fin-row .fv {
  font-weight: 600;
  color: #1a1f36;
}
.fin-actions {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.fin-actions .btn {
  min-width: 0;
  white-space: normal;
  word-break: break-word;
}
</style>
